export function shouldSuppressRemoteLoader(pathname: string): boolean {
  const list =
    typeof window !== 'undefined' && Array.isArray(window.NO_SHELL_LOADER)
      ? window.NO_SHELL_LOADER
      : [];
  return list.includes(pathname);
}
